import React, { useEffect } from 'react';
import {
  Box,
  Typography,
  Container,
  Button,
  Divider,
  Card,
  CardContent,
  useTheme,
  useMediaQuery
} from '@mui/material';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import { useNavigate, useLocation } from 'react-router-dom';

interface ConfirmationPageProps {
  formType?: string;
  email?: string;
}

const GuestConfirmationPage: React.FC<ConfirmationPageProps> = ({ 
  formType = "UCC Form",
  email
}) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const navigate = useNavigate();
  const location = useLocation();
  
    // eslint-disable-next-line no-console
    console.log("isMobile", isMobile, location)

  // Prevent going back to the form
  useEffect(() => {
    const preventGoingBack = () => {
      window.history.forward();
    };
    
    window.history.pushState(null, '', window.location.href);
    window.addEventListener('popstate', preventGoingBack);
    
    return () => {
      window.removeEventListener('popstate', preventGoingBack);
    };
  }, []);
  
  const handleGoToHomepage = () => {
    navigate('/');
  };

  return (
    <Container maxWidth="md" sx={{ py: 8 }}>
      <Card
        elevation={3}
        sx={{
          borderRadius: 2,
          overflow: 'hidden',
        }}
      >
        <Box
          sx={{
            backgroundColor: 'primary.main',
            py: 3,
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            gap: 2
          }}
        >
          <CheckCircleOutlineIcon sx={{ color: 'white', fontSize: 48 }} />
          <Typography variant="h4" component="h1" color="white" fontWeight="500">
            Submission Confirmed
          </Typography>
        </Box>
        
        <CardContent sx={{ p: 4 }}>
          <Box sx={{ textAlign: 'center', mb: 4 }}>
            <Typography variant="h5" gutterBottom>
              Thank you for submitting your {formType}
            </Typography>
            <Typography variant="body1" color="text.secondary" sx={{ mb: 3 }}>
              Your submission has been received and is being processed.
            </Typography>
            
            <Divider sx={{ my: 3 }} />
            
            {email && (
              <Typography variant="body1" sx={{ mb: 2 }}>
                A confirmation has been sent to <strong>{email}</strong>
              </Typography>
            )}
            
            <Typography variant="body2" color="text.secondary" sx={{ mb: 4 }}>
              If you have any questions or need assistance, please contact our support team.
            </Typography>
            
            <Button
              variant="contained"
              size="large"
              onClick={handleGoToHomepage}
              sx={{ px: 4, py: 1 }}
            >
              Return to Homepage
            </Button>
          </Box>
        </CardContent>
      </Card>
    </Container>
  );
};

export default GuestConfirmationPage;